import { Stack, StackProps } from '@mui/material';

function ModalFooter(props: StackProps) {
    const { sx, children } = props;

    return (
        <Stack
            sx={{
                // Default props
                gridArea: 'footer',
                gap: 2.5,
                width: '100%',
                p: 2.5,
                flexShrink: 0,
                // Custom props
                ...sx,
            }}
        >
            {children}
        </Stack>
    );
}

export default ModalFooter;
